import React from 'react';
import ManageExclusionAccountsComponentVM from './ManageExclusionAccountsComponentVM';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { ModalUtils, Validation } from '@singularsystems/neo-core';
import { TextConstants } from '../../../Common/TextConstants';

interface IManageExclusionAccountsComponentProps {
    viewModel: ManageExclusionAccountsComponentVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageExclusionAccountsComponent extends React.Component<IManageExclusionAccountsComponentProps> {

    public render() {
        const viewModel = this.props.viewModel;

        return (
            <div>
                <Neo.Card title={TextConstants.Titles.AddAccountExclusion}>
                    <div>
                        <Neo.Form model={viewModel.managedExclusionAccount}
                            validationDisplayMode={Validation.DisplayMode.AfterSubmit}
                            onSubmit={() => this.props.onSave()}
                            onInvalid={this.onFormInvalid}>
                            <Neo.GridLayout lg={3}>
                                <div className="container">
                                        <label>{TextConstants.Labels.Broker}</label>
                                        <Neo.AutoCompleteDropDown
                                            itemSource={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                            bind={viewModel.managedExclusionAccount.meta.staticServiceProviderFileGroupingId}
                                            bindDisplay={viewModel.managedExclusionAccount.meta.brokerName}
                                            displayMember={"serviceProviderGroupingName"} 
                                            items={viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                            .sort((x,y)=> x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}/>
                                </div>
                                <Neo.FormGroup
                                        label={TextConstants.Labels.AccountNumber}
                                        bind={viewModel.managedExclusionAccount.meta.accountNumber} />
                            </Neo.GridLayout>
                            <br />
                            <Neo.GridLayout lg={3}>
                                <div className="container">

                                </div>
                            </Neo.GridLayout>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2" isSubmit
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>
                    </div>
                </Neo.Card >
            </div >
        );
    }

    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidAccount);
        }
    }
}